
import React from 'react'

export const ThankYou = () => {
  return (
    <div  style={{
      position: "relative",
      zIndex: 100,
      backgroundImage: "var(--bg-image)",
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}>
    <div className="container "  >
  <div className="row justify-content-center text-center pb-5" style={{paddingTop:'150px'}}>
    <div className="col-lg-8">
      <div className="card shadow border-0 rounded-3 p-4">
        <h2 className="mb-4  fw-bold" style={{color:'#9c5336'}}>
          Thank you for your message
        </h2>
        <p className="mb-4 fs-5">
          Our team will get in touch shortly.
        </p>
        <img loading="lazy"
          src="https://redlionandcompany.com/Assets/kamarezOfArica/Package%203/C01.webp"
          alt="Thank you"
          className="img-fluid rounded-3"
        />
      </div>
    </div>
  </div>
</div>
</div>
  )
}
